import { FormStore } from '@roc/feature-app-core';
import { parseAddress } from '@roc/feature-utils';
import { computed, makeObservable, reaction } from 'mobx';

const trackRecordPropertyForm = {
  fields: {
    screenType: {
      value: 'addProperty',
      error: null,
      message: 'Please select an option',
      rule: 'required',
    },
    dealType: {
      value: '',
      error: null,
      message: '',
      rule: '',
    },
    bridge: {
      value: false,
      error: null,
      message: '',
      rule: '',
    },
    term: {
      value: false,
      error: null,
      message: '',
      rule: '',
    },
    groundUp: {
      value: false,
      error: null,
      message: '',
      rule: '',
    },
    entityName: {
      value: '',
      error: null,
      message: 'The Entity Name is required',
      rule: 'required',
    },
    fullAddress: {
      value: '',
      error: null,
      message: 'The Address is required',
      rule: 'required',
    },
    address2: {
      value: '',
      error: null,
      rule: '',
    },
    purchaseAddress: {
      value: '',
      error: null,
      message: '',
      rule: '',
    },
    purchaseState: {
      value: '',
      error: null,
      message: 'The State is required',
      rule: 'required',
    },
    entityState: {
      value: '',
      error: null,
      message: '',
      rule: '',
    },
    purchaseCity: {
      value: '',
      error: null,
      message: 'The City is required',
      rule: 'required',
    },
    purchaseZipcode: {
      value: '',
      error: null,
      message: 'The Zipcode is required and must be 5 digits',
      rule: 'required|regex:/^\\d{5}$/|alpha_dash',
    },
    purchaseDate: {
      value: null,
      error: null,
      message: 'The Purchase Date is required',
      rule: 'required',
    },
    purchasePrice: {
      value: null,
      error: null,
      message: 'The Purchase Price is required',
      rule: '',
    },
    purchasedFrom: {
      value: '',
      error: null,
      rule: ''
    },
    saleDate: {
      value: null,
      error: null,
      rule: '',
    },
    salePrice: {
      value: null,
      error: null,
      rule: '',
    },
    rehabBudget: {
      value: null,
      error: null,
      message: 'The Rehab Budget is required',
      rule: '',
    },
    verifiedTrackRecordsId: {
      value: null,
      error: null,
      rule: '',
    },
    isVerified: {
      value: false,
      error: null,
      rule: '',
    },
    comment: {
      value: null,
      error: null,
      rule: '',
    }
  },
  meta: {
    isValid: false,
    error: null,
  },
};

export class TrackRecordPropertyFormStore extends FormStore {

  constructor(globalStore) {
    super({ ...trackRecordPropertyForm }, globalStore);

    makeObservable(this, {
      groundUpSelected: computed,
      bridgeSelected: computed,
      termSelected: computed
    });

    let prev = {
      groundUp: this.groundUpSelected,
      bridge: this.bridgeSelected,
      term: this.termSelected,
    };

    reaction(
      () => ({
        groundUp: this.groundUpSelected,
        bridge: this.bridgeSelected,
        term: this.termSelected,
      }),
      ({ groundUp, bridge, term }) => {
        const groundUpBecameTrue = groundUp && !prev.groundUp;
        const groundUpBecameFalse = !groundUp && prev.groundUp;

        const bridgeBecameTrue = bridge && !prev.bridge;
        const bridgeBecameFalse = !bridge && prev.bridge;

        if (groundUpBecameTrue) {
          if (this.form.fields.bridge.value !== true) this.onFieldChange('bridge', true);
          if (this.form.fields.term.value !== true) this.onFieldChange('term', true);
        }
        if (groundUpBecameFalse) {
          if (this.form.fields.bridge.value !== false) this.onFieldChange('bridge', false);
          if (this.form.fields.term.value !== false) this.onFieldChange('term', false);
        }

        if (bridgeBecameTrue) {
          if (this.form.fields.term.value !== true) this.onFieldChange('term', true);
        }
        if (bridgeBecameFalse) {
          if (this.form.fields.term.value !== false) this.onFieldChange('term', false);
        }

        prev = { groundUp, bridge, term };
      }
    );
  }

  saveAddressField(address: string, addressDetails, geometryDetails) {
    const p = parseAddress(address, addressDetails, geometryDetails);

    const num = p.street_number?.trim();
    const st = p.street?.trim();
    const city = p.city?.trim();
    const state = p.state?.trim();
    const zip = p.zip?.trim();

    // Build a clean street address:
    let streetAddress = address?.trim() || '';
    if (num && st) streetAddress = `${num} ${st}`;
    else if (st) streetAddress = st;
    else if (num) streetAddress = num;

    this.onFieldChange('fullAddress', address);
    this.onFieldChange('purchaseAddress', streetAddress);

    if (city) this.onFieldChange('purchaseCity', city);
    if (state) this.onFieldChange('purchaseState', state);
    if (zip) this.onFieldChange('purchaseZipcode', zip);
  }

  get groundUpSelected() {
    return this.form.fields.groundUp.value === true;
  }
  get bridgeSelected() {
    return this.form.fields.bridge.value === true;
  }
  get termSelected() {
    return this.form.fields.term.value === true;
  }
}